if (!customElements.get('managed-colour-tooltip')) {
  customElements.define('managed-colour-tooltip', class extends HTMLElement {
    connectedCallback() {
      this.trigger = this.closest('.managed-colour__choice');
      if (!this.trigger) return;
      this.focusTarget = this.trigger.control || this.trigger;
      this.listeners = new AbortController();
      const options = { signal: this.listeners.signal };
      this.trigger.addEventListener('pointerenter', (event) => {
        this.hovered = event.pointerType !== 'touch';
        this.update();
      }, options);
      this.trigger.addEventListener('pointerleave', () => {
        this.hovered = false;
        this.update();
      }, options);
      this.focusTarget.addEventListener('focus', () => {
        this.focused = this.focusTarget.matches(':focus-visible');
        this.update();
      }, options);
      this.focusTarget.addEventListener('blur', () => {
        this.focused = false;
        this.update();
      }, options);
      this.focusTarget.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') this.hide();
      }, options);
      this.focused = this.focusTarget.matches(':focus-visible');
      this.update();
    }

    disconnectedCallback() {
      this.listeners?.abort();
      this.hide();
      this.hovered = false;
      this.focused = false;
    }

    update() {
      if (!this.hovered && !this.focused) return this.hide();
      this.setAttribute('data-open', '');
      this.position();
      if (!this.hasAttribute('data-open') || this.viewportListeners) return;
      this.viewportListeners = new AbortController();
      const options = { passive: true, signal: this.viewportListeners.signal };
      const position = () => this.position();
      window.addEventListener('resize', position, options);
      document.addEventListener('scroll', position, { ...options, capture: true });
      window.visualViewport?.addEventListener('resize', position, options);
      window.visualViewport?.addEventListener('scroll', position, options);
    }

    position() {
      if (!this.hasAttribute('data-open')) return;
      const viewport = window.visualViewport;
      const width = Math.min(document.documentElement.clientWidth, viewport?.width || Infinity);
      const edge = viewport?.offsetLeft || 0;
      const gap = parseFloat(getComputedStyle(this).paddingInlineStart) || 0;
      this.style.setProperty('--managed-colour-tooltip-available-width', `${Math.max(0, width - 2 * gap)}px`);
      this.style.setProperty('--managed-colour-tooltip-shift', '0px');
      if (!this.getClientRects().length) return this.hide();
      const rect = this.getBoundingClientRect();
      const left = Math.max(edge + gap, Math.min(rect.left, edge + width - gap - rect.width));
      this.style.setProperty('--managed-colour-tooltip-shift', `${left - rect.left}px`);
    }

    hide() {
      this.removeAttribute('data-open');
      this.viewportListeners?.abort();
      this.viewportListeners = null;
    }
  });
}
